import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberEye = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 94 94",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 94,
			height: 94,
			rx: 47,
			fill: "#1A383C"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "external-circle",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M47 5C70.1804 5 89 23.8196 89 47C89 70.1804 70.1804 89 47 89C23.8196 89 5 70.1804 5 47C5 23.8196 23.8196 5 47 5ZM47 6.7984C69.1879 6.7984 87.2017 24.8121 87.2017 47.0001C87.2017 69.188 69.188 87.2018 47 87.2018C24.8121 87.2018 6.7983 69.1881 6.7983 47.0001C6.7983 24.8123 24.812 6.7984 47 6.7984Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M76.3844 46.782C76.3844 38.7933 73.1634 31.1318 67.4299 25.4829L62.0254 30.8077C66.3255 35.0443 68.7413 40.7905 68.7413 46.782H76.3844Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M45.8164 76.903C53.9248 76.903 61.701 73.7295 67.4345 68.0806L62.03 62.7559C57.7299 66.9925 51.8977 69.3726 45.8164 69.3726V76.903Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M15.2441 46.7823C15.2441 54.7711 18.4652 62.4326 24.1986 68.0815L29.6032 62.7567C25.303 58.52 22.8873 52.7739 22.8873 46.7823H15.2441Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M45.8153 16.661C37.707 16.661 29.9307 19.8345 24.1973 25.4834L29.6018 30.8082C33.9019 26.5715 39.7341 24.1914 45.8153 24.1914V16.661Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M45.8164 80.0985C64.4922 80.0985 79.6319 65.1822 79.6319 46.7819C79.6319 37.9458 76.0693 29.4716 69.7276 23.2235L68.9807 23.9594C75.1243 30.0123 78.5757 38.2218 78.5757 46.7819C78.5757 64.6074 63.9089 79.0578 45.8165 79.0578V80.0985L45.8164 80.0985Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M45.9798 13.4662C27.3042 13.3769 12.091 28.2207 12.0004 46.6209C11.9569 55.4569 15.4778 63.9481 21.7886 70.2264L22.5391 69.4941C16.4254 63.4119 13.0145 55.1859 13.0567 46.626C13.1445 28.8007 27.8823 14.4205 45.9744 14.5071L45.9796 13.4664L45.9798 13.4662Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M65.7089 27.1827C60.4331 21.9848 53.2775 19.0646 45.8164 19.0646V19.5553C53.1454 19.5553 60.1743 22.4238 65.3567 27.5298L65.7089 27.1827Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M25.9233 27.1833C20.6475 32.3813 17.6836 39.4313 17.6836 46.7823H18.1817C18.1817 39.5615 21.0931 32.6363 26.2755 27.5304L25.9233 27.1833Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M20.2852 74.4408C26.8679 80.3774 35.3588 83.846 44.274 84.2403L44.7576 73.6253C38.3689 73.3427 32.2842 70.8571 27.5669 66.6029L20.2852 74.4408Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M74.0529 72.0977C80.0784 65.6121 83.5989 57.2464 83.9991 48.4628L73.2252 47.9863C72.9384 54.2807 70.4156 60.2757 66.0977 64.9233L74.0529 72.0977Z",
					fill: "#79FBAF"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M72.0179 19.1026C71.6489 18.7635 71.2733 18.4317 70.891 18.1073L65.2839 24.5193C65.5806 24.7712 65.8723 25.0288 66.1587 25.292L72.0179 19.1026ZM70.3093 17.6232C69.9206 17.3063 69.5256 16.997 69.1246 16.6954L63.9125 23.4232C64.2238 23.6573 64.5304 23.8975 64.8322 24.1435L70.3093 17.6232ZM68.5148 16.2461C68.1078 15.9524 67.6949 15.6667 67.2765 15.389L62.4776 22.4089C62.8025 22.6245 63.123 22.8464 63.439 23.0744L68.5148 16.2461ZM66.6407 14.9761C66.2168 14.7066 65.7875 14.4455 65.3531 14.1927L60.9843 21.4801C61.3216 21.6763 61.6548 21.8791 61.984 22.0883L66.6407 14.9761ZM64.6937 13.8176C64.2543 13.5733 63.8101 13.3376 63.3612 13.1106L59.4378 20.64C59.7863 20.8162 60.1312 20.9992 60.4723 21.1888L64.6937 13.8176ZM62.6804 12.7746C62.2271 12.5564 61.7695 12.347 61.3079 12.1465L57.8436 19.8915C58.202 20.0471 58.5573 20.2097 58.9092 20.3791L62.6804 12.7746ZM60.6081 11.8508C60.1425 11.6594 59.6731 11.4771 59.2002 11.3039L56.2072 19.2373C56.5744 19.3717 56.9388 19.5133 57.3003 19.6619L60.6081 11.8508ZM58.4838 11.0495C58.0076 10.8856 57.528 10.7309 57.0456 10.5857L54.5344 18.6796C54.909 18.7924 55.2813 18.9125 55.6511 19.0397L58.4838 11.0495ZM56.3152 10.3735C55.8299 10.2376 55.3419 10.1112 54.8516 9.99428L52.8311 18.2205C53.2118 18.3113 53.5906 18.4094 53.9674 18.5149L56.3152 10.3735ZM54.1098 9.82505C53.6172 9.71773 53.1225 9.61999 52.6259 9.53186L51.1031 17.8615C51.4886 17.9299 51.8726 18.0058 52.2551 18.0891L54.1098 9.82505ZM51.8752 9.40619C51.3771 9.32779 50.8774 9.25908 50.3764 9.20006L49.3566 17.6039C49.7455 17.6497 50.1335 17.703 50.5202 17.7639L51.8752 9.40619ZM49.6195 9.11838C49.1175 9.06917 48.6145 9.02971 48.1109 9L47.5977 17.4485C47.9886 17.4716 48.3791 17.5022 48.7689 17.5405L49.6195 9.11838Z",
					fill: "#79FBAF"
				})
			]
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 46.5,
			cy: 46.5,
			r: 20.5,
			fill: "#0C5661"
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "pupil-shaded",
			children: [/* @__PURE__ */ _jsx("circle", {
				cx: 47,
				cy: 47,
				r: 8,
				fill: "#1A383C"
			}), /* @__PURE__ */ _jsx("circle", {
				cx: 52.5,
				cy: 39.5,
				r: 3.5,
				fill: "#CFD4D5",
				fillOpacity: .7
			})]
		})
	]
});
export default SvgCyberEye;
